import {LoginType} from '@Components/two-factor-authentication/two-factor-authentication.types';

export const isBackupCodeLoginType = (loginType: LoginType): boolean => {
  return loginType === LoginType.BACKUP_CODE;
};

export const isTOTPLoginType = (loginType: LoginType): boolean => {
  return loginType === LoginType.TOTP;
};
